import Logger from '../lib/logger';
import { getCardData } from '../lib/util.functions';

class BundlerStep extends HTMLElement {
  #NAME = 'BundlerStep'
  #includesAdded = false
  #step

  constructor() {
    super();
    Logger.info(`${this.#NAME} (step ${this.dataset.bundlerStep}) > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} (step ${this.#step}) > connectedCallback`);
    this.addEventListener('bundlestep:event', (e) => this.#onBundleStepEvent(e));
    this.includeCards = this.querySelectorAll('product-card[data-included="true"]');
    this.form = this.querySelector('form');
    this.form.onsubmit = (e) => e.preventDefault();
  }

  static get observedAttributes() {
    return ['data-bundler-step', 'data-show'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > ${name} > ${newValue}`);
    //
    if (name === 'data-bundler-step') {
      this.#step = parseInt(newValue);
    }
    //
    if (name === 'data-show' && newValue !== oldValue && newValue === 'true') {
      const firstCard = this.querySelector('product-card');
      if (firstCard.dataset.included === 'true' && firstCard.dataset.solo === 'true'
        && firstCard.querySelector('[data-product-btn] input[type="radio"]:not(input:checked)')) {
          const data = getCardData(firstCard, 'add', { quantity: 1 }).data;
          this.#dispatchCustomBundleEvent('addAccessory', data, true);
      }
    }
  }

  #onBundleStepEvent(e) {
    Logger.info(`${this.#NAME} (step ${this.#step})`, e.detail, 'includesAdded:', this.#includesAdded);
    //
    switch (e.detail.name) {
      case 'add':
        this.#dispatchCustomBundleEvent('addAccessory', { ...e.detail.data }, e.detail.replace);
        if (e.detail.data.groupIndex == '1' && !this.#includesAdded) this.#updateIncludes(true);
        break;

      case 'remove':
        this.#dispatchCustomBundleEvent('updateAccessory', { ...e.detail.data }, e.detail.replace);
        if (e.detail.data.groupIndex == '1') {
          const row1 = document.querySelector(`.bundler-side-cart__item-container:nth-child(${this.#step}) [data-row="1"]`);
          if (this.#includesAdded) this.#updateIncludes(false, row1);
          if (!row1.children.length 
            || (row1.children.length === 1 && row1.firstElementChild.className === 'bundler-side-cart__item-container__placeholder')) {
              this.#dispatchCustomBundleEvent('updateCurrentStep', { step: this.#step }, true);
            }
        }
        break;
    
      default:
        this.#dispatchCustomBundleEvent('updateAccessory', { ...e.detail.data }, e.detail.replace);
        break;
    }
  }

  #updateIncludes(add, row1) {
    /* console.log('#updateIncludes', add, row1, this.includeCards); */
    if (this.includeCards.length) {
      let data
      if (add) {
        // add includes
        this.#includesAdded = true;
        let grandparent, card, sideCartItem;
        this.includeCards.forEach(el => {
          if (el.dataset.solo === 'true' && el.querySelector('[data-product-btn] input[type="radio"]:not(input:checked)')) {
            grandparent = el.parentElement.parentElement;
            console.log('grandparent', grandparent)
            card = document.querySelector(`product-card[data-product-id="${grandparent.dataset.onlyForProduct}"]:has(input:checked)`);
            sideCartItem = document.querySelector(`side-cart-selected-item[data-variant-id="${el.dataset.variantId}"]`);
            if (!sideCartItem && (!grandparent.dataset.onlyForProduct || card)) {
              data = getCardData(el, 'add', { price: '0', quantity: 1, options: el.dataset.options || null }).data;
              console.log('add include', data.title, data);
              this.#dispatchCustomBundleEvent('addAccessory', data, true);
            }
          }
        });
      } else {
        // remove includes
        if (!row1.children.length || (row1.children.length === 1 && row1.firstElementChild.className === 'bundler-side-cart__item-container__placeholder')) {
          this.#includesAdded = false;
          this.includeCards.forEach(el => {
            if (el.querySelector(`.bundler-grid__items__grid-item__button input:checked`)) {
              data = getCardData(el, 'remove').data;
              console.log('remove include', data.title, data);
              this.#dispatchCustomBundleEvent('updateAccessory', data, true);
            }
          });
        }
      }
    }
  }

  #dispatchCustomBundleEvent(name, data, replace = false) {
    const event = new CustomEvent('custombundle:event', {
      detail: {
        name,
        data,
        replace
      },
      bubbles: true
    });
    this.dispatchEvent(event);
  }
}

customElements.define('bundler-step', BundlerStep);

